import { gql } from 'glimmer-apollo';

export const ESPORTS_TOURNAMENT_BANNER_QUERY = gql`
  query ($slug: String) {
    tournament: tournament(slug: $slug) {
      title
      slug
      game {
        logo {
          url
        }
        title
        slug
      }
      matches {
        isLive
        isFinal
        scheduledDate
        slug
        rounds {
          isLive
          victor {
            slug
          }
        }
        victor {
          slug
        }
        teams {
          name
          slug
          logo {
            url
          }
        }
      }
    }
  }
`;
